import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import React from "react";

export interface IKeyDriveSelect<T> {
    items: T[];
    value: any;
    label?: string | undefined;
    needFullWidth?: boolean;
    onChange?: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void) | undefined;
    renderItem: (item: T) => React.ReactNode;
    keyExtract: (item: T) => any;
    valueOptionClear?: string;
    showOptionClear?: boolean;
    onFocus?: () => void;
    disabled?: boolean;

}

export interface IKeyDriveSelectType {
    name: string;
    value: any;
    id: string;
    optionalText?: string;
}

export function KeyDriveSelect<T extends object>({
    items,
    value,
    label,
    needFullWidth,
    onChange,
    renderItem,
    keyExtract,
    valueOptionClear,
    showOptionClear,
    onFocus,
    disabled
}: IKeyDriveSelect<T>) {
    return (
        <FormControl variant="standard" fullWidth>
            <InputLabel id="demo-simple-select-label">{label}</InputLabel>
            <Select
                onFocus={onFocus}
                fullWidth={needFullWidth}
                onChange={onChange}
                disabled={disabled}
                value={value}
                labelId="demo-simple-select-label"
                label={label}
                variant="standard"
                MenuProps={{
                    sx: {
                        marginTop: "15px",
                    },
                    MenuListProps: {
                        sx: {
                            border: "1px solid #0000001A",
                            borderRadius: "4px",
                            paddingTop: 0,
                            paddingBottom: 0
                        }
                    },
                    disablePortal: true
                }}
            >
                {showOptionClear &&
                <MenuItem value="" sx={{
                        ":hover": {
                            backgroundColor: "#D2E0E8",
                            color: "#22638D"
                        },
                        borderBottom: "1px solid #0000001A"
                    }}>
                        {valueOptionClear}
                    </MenuItem>}
                {items.map(item => (
                    <MenuItem key={keyExtract(item)} value={keyExtract(item)} sx={{
                        ":hover": {
                            backgroundColor: "#D2E0E8",
                            color: "#22638D"
                        },
                        borderBottom: "1px solid #0000001A"
                    }}>
                        {renderItem(item)}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    )
}